/* eslint-disable no-unused-expressions */
import { createFromAudioFile, updateEpisodeContentLengthAndUrl } from '../../resources/episode';
import fileUpload from '../../services/file-upload';
import getAudioDurationFromFile from './get-audio-duration-from-file';
import { getAudioMarker } from './markers';

export async function uploadEpisodeAudio({
  audioMarker,
  episodeId,
  file,
  onUpdateAudioMarkerWithDuration,
  onUpdateAudioMarkerWithMedia,
  showId,
}) {
  const duration = await getAudioDurationFromFile(file);

  await onUpdateAudioMarkerWithDuration(audioMarker.id, duration);

  const mediaUrl = await fileUpload.begin(
    { path: `${showId}/${episodeId}`, id: audioMarker.id },
    'media',
    file
  );

  await updateEpisodeContentLengthAndUrl(episodeId, file.size, mediaUrl);

  await onUpdateAudioMarkerWithMedia(audioMarker.id, {
    url: mediaUrl,
    type: file.type,
  });

  return mediaUrl;
}

export async function createAndUploadEpisode({
  file,
  onFetchEpisodeMarkers,
  onUpdateAudioMarkerWithDuration,
  onUpdateAudioMarkerWithMedia,
  showId,
}) {
  const episode = await createFromAudioFile(showId);

  // Upon creating an episode, an audio marker is also created and so we
  // must fetch episode markers after having created the new episode.
  const markers = await onFetchEpisodeMarkers(episode.id);

  const audioMarker = getAudioMarker(markers);

  // Do not wait for the upload, since upload status is tracked by the store
  uploadEpisodeAudio({
    audioMarker,
    episodeId: episode.id,
    file,
    onUpdateAudioMarkerWithDuration,
    onUpdateAudioMarkerWithMedia,
    showId,
  });

  return episode;
}
